const warned = new Set<string>()

/** Warn once (per process) that `oldName` was renamed to `newName`. */
export function warnRenamed(oldName: string, newName: string): void {
  if (warned.has(oldName)) return
  warned.add(oldName)
  // eslint-disable-next-line no-console
  console.warn(
    `[RUN] "${oldName}" is deprecated and will be removed in the next major ` +
      `version. Use "${newName}" instead.`,
  )
}
